import { Box, Grid, Modal } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './BrokerAccount.scss';
import { BrokerAccountSearchSelector, setShowInputBrokerAccountPanel } from './reducers/BrokerAccountSearchReducer';
import BrokerAccountInput from './BrokerAccountInput';
import BrokerAccountSearch from './BrokerAccountSearch';
import BrokerAccountTable from './BrokerAccountTable';

const BrokerAccount: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const brokerAccountSearchModel = useSelector(BrokerAccountSearchSelector);

    return (
        <>
            <Grid container className="tonnage">
                <Grid item lg={2} xs={12} className="left-search-area">
                    <BrokerAccountSearch></BrokerAccountSearch>
                </Grid>
                <Grid item lg={10} xs={12} className="right-content">
                    <Grid container className="input-fields">
                        <BrokerAccountInput></BrokerAccountInput>
                    </Grid>
                    <Grid container className="datatable">
                        <BrokerAccountTable></BrokerAccountTable>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default BrokerAccount;